import { render } from "./active-customers.vue?vue&type=template&id=f990528c"
import script from "./active-customers.vue?vue&type=script&lang=js"
export * from "./active-customers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__